import { IYAxisTickProps } from './types';

export const YAxisTick = ({ x, y, width, height, payload }: IYAxisTickProps) => (
  <text
    width={width}
    height={height}
    x={(x ?? 0) + 10}
    y={(y ?? 0) + 4}
    textAnchor="middle"
    fill="#0000008a"
    className="typography-title-3"
  >
    {payload?.value}
  </text>
);
